import React, {useContext} from 'react';
import './Button.scss';
import { constructClassNames } from '../../helpers/helpers';
import { Loader } from './';
import {I18nContext} from '../../contexts/i18nContext';

const Button = (
  {
    type='primary',
    label,
    action,
    width='fitContent',
    fullWidth,
    disabled=false,
    pending=false,
    margin,
    size='normal',
  }
) => {
  const { t } = useContext(I18nContext);

  const classes = [
    {name: 'primary', condition: type === 'primary'},
    {name: 'secondary', condition: type === 'secondary'},
    {name: 'pending', condition: pending},
    {name: 'disabled', condition: disabled},
    {name: 'small', condition: size === 'small'}
  ];

  return (
    <div
      className={constructClassNames('button', classes)}
      onClick={!disabled && !pending ? action : null}
      style={{
        width: fullWidth ? '100%' : width,
        marginLeft: margin === 'left' ? '16px' : 0,
        marginRight: margin === 'right' ? '16px' : 0
      }}
    >
      {!pending && (<div className='buttonLabel'>{t(label)}</div>)}
      {pending && (<Loader size={40} light={type === 'primary'} />) }
    </div>
  );
};

export default Button;
